import { render, staticRenderFns } from "./ChineseForm.vue?vue&type=template&id=3e352a30&scoped=true&"
import script from "./ChineseForm.vue?vue&type=script&lang=js&"
export * from "./ChineseForm.vue?vue&type=script&lang=js&"
import style0 from "./ChineseForm.vue?vue&type=style&index=0&id=3e352a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e352a30",
  null
  
)

export default component.exports